export function set(storage, key, value) {
    if (typeof key === 'object') {
        for (const name of Object.keys(key ?? {})) {
            value = key[name];
            set(storage, name, value);
        }
    }
    else {
        storage.setItem(key, JSON.stringify(value));
    }
}
export function get(storage, key) {
    const raw = storage.getItem(key);
    if (raw != null)
        return JSON.parse(raw);
    else
        return null;
}
export function del(storage, key) {
    storage.removeItem(key);
}
export const ObjectStorage = { set, get, del };
